export class ItemcontainerUtil {

  static isProject(itemContainerType: number): boolean {
    return itemContainerType == 3;
  }
}
